module.exports = __webpack_public_path__ + "fa-brands-400.a046592bac8f2fd96e99.woff";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-brands-400.woff
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-brands-400.woff
// module chunks = styles